import styled, { css } from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint } from 'react-components'

export const ReviewContainer = styled.div(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        margin: ${theme.spacing.medium} 0 0 ${theme.spacing.medium};
        padding: ${theme.spacing.small};
        border-radius: ${theme.typography.border.radius.medium};
        border-left: 2px solid ${theme.colors.black};
        background-color: ${theme.colors.tfwBlack3};

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            margin-left: 1.25rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            margin-left: ${theme.spacing.large};
        }
    `,
)

export const ReviewTitleWrapper = styled.div(
    ({ theme }) => css`
        display: flex;
        justify-content: space-between;
        margin-bottom: ${theme.spacing.xxxSmall};
    `,
)

export const ReviewAnswerTitle = styled.div`
    flex: 1;
`

export const ReviewAnswerDate = styled.div`
    margin-left: ${({ theme }) => theme.spacing.small};
`

export const ReviewAnswerTextContainer = styled.div`
    margin-top: ${({ theme }) => theme.spacing.xxxSmall};
`
